/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BulkRetrieveUsersResponse } from '../models/bulk-retrieve-users-response';
import { Empty } from '../models/empty';
import { getUserInvitation } from '../fn/users/get-user-invitation';
import { GetUserInvitation$Params } from '../fn/users/get-user-invitation';
import { HalJson } from '../models/hal-json';
import { RoleListResponse } from '../models/role-list-response';
import { rolesGet } from '../fn/users/roles-get';
import { RolesGet$Params } from '../fn/users/roles-get';
import { tenantsTenantIdRolesPost } from '../fn/users/tenants-tenant-id-roles-post';
import { TenantsTenantIdRolesPost$Params } from '../fn/users/tenants-tenant-id-roles-post';
import { tenantsTenantIdRolesRoleNameDelete } from '../fn/users/tenants-tenant-id-roles-role-name-delete';
import { TenantsTenantIdRolesRoleNameDelete$Params } from '../fn/users/tenants-tenant-id-roles-role-name-delete';
import { tenantsTenantIdRolesRoleNamePut } from '../fn/users/tenants-tenant-id-roles-role-name-put';
import { TenantsTenantIdRolesRoleNamePut$Params } from '../fn/users/tenants-tenant-id-roles-role-name-put';
import { UserCurrentResponse } from '../models/user-current-response';
import { UserRole } from '../models/user-role';
import { usersBulkRetrievePost } from '../fn/users/users-bulk-retrieve-post';
import { UsersBulkRetrievePost$Params } from '../fn/users/users-bulk-retrieve-post';
import { usersCurrentGet } from '../fn/users/users-current-get';
import { UsersCurrentGet$Params } from '../fn/users/users-current-get';
import { usersGet } from '../fn/users/users-get';
import { UsersGet$Params } from '../fn/users/users-get';
import { usersPost } from '../fn/users/users-post';
import { UsersPost$Params } from '../fn/users/users-post';
import { UsersResponse } from '../models/users-response';
import { usersUserIdCallCentersPut } from '../fn/users/users-user-id-call-centers-put';
import { UsersUserIdCallCentersPut$Params } from '../fn/users/users-user-id-call-centers-put';
import { usersUserIdDelete } from '../fn/users/users-user-id-delete';
import { UsersUserIdDelete$Params } from '../fn/users/users-user-id-delete';
import { usersUserIdInvitationPost } from '../fn/users/users-user-id-invitation-post';
import { UsersUserIdInvitationPost$Params } from '../fn/users/users-user-id-invitation-post';
import { usersUserIdPut } from '../fn/users/users-user-id-put';
import { UsersUserIdPut$Params } from '../fn/users/users-user-id-put';
import { usersUserIdResetPasswordPost } from '../fn/users/users-user-id-reset-password-post';
import { UsersUserIdResetPasswordPost$Params } from '../fn/users/users-user-id-reset-password-post';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `rolesGet()` */
  static readonly RolesGetPath = '/roles';

  /**
   * Gets all roles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGet$Response(params: RolesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleListResponse>> {
    return rolesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all roles.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rolesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGet(params: RolesGet$Params, context?: HttpContext): Observable<RoleListResponse> {
    return this.rolesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoleListResponse>): RoleListResponse => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdRolesPost()` */
  static readonly TenantsTenantIdRolesPostPath = '/tenants/{tenantId}/roles';

  /**
   * Creates custom roles for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdRolesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdRolesPost$Response(params: TenantsTenantIdRolesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRole>> {
    return tenantsTenantIdRolesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates custom roles for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdRolesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdRolesPost(params: TenantsTenantIdRolesPost$Params, context?: HttpContext): Observable<UserRole> {
    return this.tenantsTenantIdRolesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserRole>): UserRole => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdRolesRoleNamePut()` */
  static readonly TenantsTenantIdRolesRoleNamePutPath = '/tenants/{tenantId}/roles/{roleName}';

  /**
   * Updates custom role for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdRolesRoleNamePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdRolesRoleNamePut$Response(params: TenantsTenantIdRolesRoleNamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<UserRole>> {
    return tenantsTenantIdRolesRoleNamePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates custom role for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdRolesRoleNamePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdRolesRoleNamePut(params: TenantsTenantIdRolesRoleNamePut$Params, context?: HttpContext): Observable<UserRole> {
    return this.tenantsTenantIdRolesRoleNamePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserRole>): UserRole => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdRolesRoleNameDelete()` */
  static readonly TenantsTenantIdRolesRoleNameDeletePath = '/tenants/{tenantId}/roles/{roleName}';

  /**
   * Deletes custom role for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdRolesRoleNameDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdRolesRoleNameDelete$Response(params: TenantsTenantIdRolesRoleNameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return tenantsTenantIdRolesRoleNameDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes custom role for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdRolesRoleNameDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdRolesRoleNameDelete(params: TenantsTenantIdRolesRoleNameDelete$Params, context?: HttpContext): Observable<void> {
    return this.tenantsTenantIdRolesRoleNameDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `usersGet()` */
  static readonly UsersGetPath = '/users';

  /**
   * Search users by match criteria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet$Response(params: UsersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersResponse>> {
    return usersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Search users by match criteria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersGet(params: UsersGet$Params, context?: HttpContext): Observable<UsersResponse> {
    return this.usersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsersResponse>): UsersResponse => r.body)
    );
  }

  /** Path part for operation `usersPost()` */
  static readonly UsersPostPath = '/users';

  /**
   * Creates a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersPost$Response(params: UsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
    return usersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersPost(params: UsersPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
}> {
    return this.usersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
}>): {
'_links'?: HalJson;
} => r.body)
    );
  }

  /** Path part for operation `usersUserIdCallCentersPut()` */
  static readonly UsersUserIdCallCentersPutPath = '/users/{userId}/call-centers';

  /**
   * Updates the call center for the user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdCallCentersPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUserIdCallCentersPut$Response(params: UsersUserIdCallCentersPut$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
    return usersUserIdCallCentersPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates the call center for the user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdCallCentersPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUserIdCallCentersPut(params: UsersUserIdCallCentersPut$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
}> {
    return this.usersUserIdCallCentersPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
}>): {
'_links'?: HalJson;
} => r.body)
    );
  }

  /** Path part for operation `usersUserIdPut()` */
  static readonly UsersUserIdPutPath = '/users/{userId}';

  /**
   * Updates a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUserIdPut$Response(params: UsersUserIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
    return usersUserIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersUserIdPut(params: UsersUserIdPut$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
}> {
    return this.usersUserIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
}>): {
'_links'?: HalJson;
} => r.body)
    );
  }

  /** Path part for operation `usersUserIdDelete()` */
  static readonly UsersUserIdDeletePath = '/users/{userId}';

  /**
   * Deletes the specified user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdDelete$Response(params: UsersUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
}>> {
    return usersUserIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes the specified user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdDelete(params: UsersUserIdDelete$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
}> {
    return this.usersUserIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
}>): {
'_links'?: HalJson;
} => r.body)
    );
  }

  /** Path part for operation `usersBulkRetrievePost()` */
  static readonly UsersBulkRetrievePostPath = '/users/bulk-retrieve';

  /**
   * Retrieve multiple users by their IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersBulkRetrievePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersBulkRetrievePost$Response(params: UsersBulkRetrievePost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: BulkRetrieveUsersResponse;
}>> {
    return usersBulkRetrievePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve multiple users by their IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersBulkRetrievePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usersBulkRetrievePost(params: UsersBulkRetrievePost$Params, context?: HttpContext): Observable<{
'_links'?: BulkRetrieveUsersResponse;
}> {
    return this.usersBulkRetrievePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: BulkRetrieveUsersResponse;
}>): {
'_links'?: BulkRetrieveUsersResponse;
} => r.body)
    );
  }

  /** Path part for operation `getUserInvitation()` */
  static readonly GetUserInvitationPath = '/users/{userId}/invitation';

  /**
   * Get invitation details for a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserInvitation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInvitation$Response(params: GetUserInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;

/**
 * The invitation URL for the user
 */
'invitationUrl'?: string;

/**
 * Expiration timestamp of the invitation
 */
'expiresAt'?: string;

/**
 * Timestamp when the invitation was sent
 */
'sentAt'?: string;
}>> {
    return getUserInvitation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get invitation details for a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserInvitation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInvitation(params: GetUserInvitation$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;

/**
 * The invitation URL for the user
 */
'invitationUrl'?: string;

/**
 * Expiration timestamp of the invitation
 */
'expiresAt'?: string;

/**
 * Timestamp when the invitation was sent
 */
'sentAt'?: string;
}> {
    return this.getUserInvitation$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;

/**
 * The invitation URL for the user
 */
'invitationUrl'?: string;

/**
 * Expiration timestamp of the invitation
 */
'expiresAt'?: string;

/**
 * Timestamp when the invitation was sent
 */
'sentAt'?: string;
}>): {
'_links'?: HalJson;

/**
 * The invitation URL for the user
 */
'invitationUrl'?: string;

/**
 * Expiration timestamp of the invitation
 */
'expiresAt'?: string;

/**
 * Timestamp when the invitation was sent
 */
'sentAt'?: string;
} => r.body)
    );
  }

  /** Path part for operation `usersUserIdInvitationPost()` */
  static readonly UsersUserIdInvitationPostPath = '/users/{userId}/invitation';

  /**
   * Invite an external user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdInvitationPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdInvitationPost$Response(params: UsersUserIdInvitationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: Empty;
}>> {
    return usersUserIdInvitationPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite an external user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdInvitationPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdInvitationPost(params: UsersUserIdInvitationPost$Params, context?: HttpContext): Observable<{
'_links'?: Empty;
}> {
    return this.usersUserIdInvitationPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: Empty;
}>): {
'_links'?: Empty;
} => r.body)
    );
  }

  /** Path part for operation `usersUserIdResetPasswordPost()` */
  static readonly UsersUserIdResetPasswordPostPath = '/users/{userId}/reset-password';

  /**
   * Reset an external user password.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersUserIdResetPasswordPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdResetPasswordPost$Response(params: UsersUserIdResetPasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: Empty;
}>> {
    return usersUserIdResetPasswordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Reset an external user password.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersUserIdResetPasswordPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersUserIdResetPasswordPost(params: UsersUserIdResetPasswordPost$Params, context?: HttpContext): Observable<{
'_links'?: Empty;
}> {
    return this.usersUserIdResetPasswordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: Empty;
}>): {
'_links'?: Empty;
} => r.body)
    );
  }

  /** Path part for operation `usersCurrentGet()` */
  static readonly UsersCurrentGetPath = '/users/current';

  /**
   * Get the current user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usersCurrentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersCurrentGet$Response(params: UsersCurrentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserCurrentResponse>> {
    return usersCurrentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the current user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usersCurrentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usersCurrentGet(params: UsersCurrentGet$Params, context?: HttpContext): Observable<UserCurrentResponse> {
    return this.usersCurrentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserCurrentResponse>): UserCurrentResponse => r.body)
    );
  }

}
